<template>
  <div class="content">
    <div class="cont-list">
      <span class="list">{{this.parentRoute.menuName+'-'+this.route.menuName}}</span>
    </div>

    <div class="content-card">
      <div class="card">
        <div class="card-head">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">折旧规则</span>
          </div>
          <!-- <div style="width:20%"> -->
          <!-- <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" v-preventReClick
            @click="handleAdd" /> -->
          <!-- </div> -->
        </div>
        <div class="card-body">
          <!-- <el-input type="text" v-model="keyWord" suffix-icon="el-icon-search" style="height:32px; width: 240px;" @change="search" /> -->
          <div>
            <template class="card-list" v-for="item in dataList">
              <div class="card-list card-data" :class="{active : item.id==activeCard}" :key="item.id" v-preventReClick @click="cardClick(item)">
                <div class="card-value td-overflow-hidden" style="width: 160px;">{{item.name}}</div>
                <template v-if="item.id==activeCard">
                  <!-- <i v-if="!isLast" class="el-icon-caret-right card-icon" /> -->
                  <!-- <i class="el-icon-delete card-icon opacity5" v-preventReClick
            @click="handleDelete(item)" /> -->
                  <i class="el-icon-edit-outline card-icon opacity5" v-preventReClick @click="handleUpdate(item, $event)" />
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div v-if="activeCard" class="card-info">
        <div class="card-head">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">折旧详情</span>
          </div>
        </div>
        <div style="margin:0 20px;height: 100%;position: relative;">
          <el-form label-width="80px">
            <el-form-item label="折旧名称:" prop="name">
              <span class="value">{{form.name}}</span>
            </el-form-item>
            <el-form-item label="折旧规则:" prop="rules">
              <span class="value" v-html="form.rules"></span>
            </el-form-item>
            <el-form-item label="备注:" prop="remark">
              <template v-if="!isUpdate">
                <span class="value">{{form.remark}}</span>
              </template>
              <template v-else>
                <el-input v-model="form.remark" placeholder="请填写备注"></el-input>
              </template>
            </el-form-item>
            <el-form-item label="启用状态:">
              <template v-if="!isUpdate">
                <span :class="{enable: form.state==1,value: form.state!=1}">已{{form.stateName}}</span>
              </template>
              <template v-else>
                <el-switch v-model="form.state" active-color="#286AB4" inactive-color="#D4D4D4" @change="switchChange" :active-value="1" :inactive-value="0">
                </el-switch>
                <span v-if="form.state">已启用</span>
                <span v-else>已禁用</span>
              </template>
            </el-form-item>

          </el-form>
          <div v-if="isUpdate" slot="footer" class="dialog-footer" style="position: absolute;top: 658px;bottom: 0px;right: 0;">
            <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
            <my-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</my-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Content from './content.vue'
import GetDataMixin from '@/mixin/getData-mixin'
import {
  SaveDepreciation,
  RemoveDepreciations,
  GetDepreciations
} from '@/api'

export default {
  name: 'assetsCategory',
  components: {
    // Content
  },
  mixins: [GetDataMixin],
  data () {
    return {
      query: {
        keyWord: '',
        pageSize: 10,
        pageIndex: 1
      },
      activeCard: '',
      isUpdate: false,
      dataList: [],
      form: {},

    }
  },
  props: {

  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      GetDepreciations(this.query)
        .then(res => {
          this.dataList = res.returnData.data
        })
    },
    handleUpdate (item, e) {
      this.isUpdate = true;
      this.form = JSON.parse(JSON.stringify(item))

      e.stopPropagation();
    },
    cardClick (item) {
      this.activeCard = item.id
      this.isUpdate = false;
      this.form = item
    },
    cancel () {
      this.isUpdate = false
    },
    submit () {
      SaveDepreciation(this.form)
        .then(res => {
          this.isUpdate = false
          this.getData()
        })
    },
    switchChange (val) {
      // console.log(val)
      if (val == 1) {
        this.form.stateName = "启用"
      }
      else {
        this.form.stateName = "禁用"
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-info {
  width: 600px;
  height: 748px;
  background: #f5f6fa;
  border-radius: 2px;
}
.card-list {
  margin-top: 0px !important;
  margin-bottom: 20px;
}

/deep/ .el-form-item__content {
  line-height: 20px !important;
  color: #606166;
  font-weight: 400;
}
/deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
.content-card {
  height: 748px;
}
</style>
